export const ScrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
}